export const ErrorType = {
	BASE_MISSING_DETAILS: 'BASE_MISSING_DETAILS',
	BASE_INVALID_AMOUNT: 'BASE_INVALID_AMOUNT',
	BASE_THIRD_PARTY_ID_MISSING: 'BASE_THIRD_PARTY_ID_MISSING',
	BASE_UNKNOWN_PAYMENT_ERROR: 'BASE_UNKNOWN_PAYMENT_ERROR',
	CC_MISSING_CARD: 'CC_MISSING_CARD',
	CC_INVALID_CARD: 'CC_INVALID_CARD',
	PP_MISSING_ACCOUNT: 'PP_MISSING_ACCOUNT',
	PP_AUTHORIZATION_FAILED: 'PP_AUTHORIZATION_FAILED',
	GOOGLE_UCB_SELECTION: 'GOOGLE_UCB_SELECTION',
	IOS_USER_CANCELLED: 'IOS_USER_CANCELLED',
	AMZ_FAILED_PROCESSING: 'AMZ_FAILED_PROCESSING'
};

/**
 * Singleton class that manages error code schemas.
 */
class ErrorCodeRegistry {
	static instance = new ErrorCodeRegistry();

	/**
	 * Initializes the error code registry with predefined error schemas.
	 * Ensures a single instance of the registry is used.
	 */
	constructor() {
		if (ErrorCodeRegistry.instance) {
			return ErrorCodeRegistry.instance;
		}

		this.errorSchemas = new Map([
			[ErrorType.BASE_MISSING_DETAILS, { description: 'Payment details are missing', fatal: true }],
			[ErrorType.BASE_UNKNOWN_PAYMENT_ERROR, { description: 'Unknown payment error', fatal: true }],
			[
				ErrorType.BASE_THIRD_PARTY_ID_MISSING,
				{
					description: 'Third Party Id does not exist or is malformed for this request',
					fatal: true
				}
			],
			[ErrorType.BASE_INVALID_AMOUNT, { description: 'Invalid payment amount', fatal: true }],
			[ErrorType.CC_MISSING_CARD, { description: 'Card number is missing', fatal: true }],
			[ErrorType.CC_INVALID_CARD, { description: 'Invalid card number', fatal: true }],
			[ErrorType.PP_MISSING_ACCOUNT, { description: 'PayPal account is missing', fatal: true }],
			[
				ErrorType.PP_AUTHORIZATION_FAILED,
				{ description: 'PayPal authorization failed', fatal: true }
			],
			[
				ErrorType.GOOGLE_UCB_SELECTION,
				{ description: 'User selected UCB credit card payment or PayPal method', fatal: false }
			],
			[ErrorType.IOS_USER_CANCELLED, { description: 'User Canceled.', fatal: false }],
			[ErrorType.AMZ_FAILED_PROCESSING, { description: 'failed processing', fatal: true }]
		]);

		ErrorCodeRegistry.instance = this;
	}

	/**
	 * Retrieves the schema for a given error code.
	 * @param {string} code - The error code to retrieve the schema for.
	 * @returns {object} The schema associated with the error code.
	 */
	getSchemaForCode(code) {
		return (
			this.errorSchemas.get(code) || this.errorSchemas.get(ErrorType.BASE_UNKNOWN_PAYMENT_ERROR)
		);
	}
}

const errorCodeRegistry = new ErrorCodeRegistry();
export { errorCodeRegistry };
